/**
 * 账号管理页懒加载壳（14.34b；MyPrivacyLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function MyAccountsLazy() {
  const { mod } = useLazyModule(() => import('./MyAccountsPage'));
  if (mod === null) return <div data-testid="my-accounts-loading-shell">加载中…</div>;
  return <mod.MyAccountsPage />;
}
